import clsx from 'clsx';
import { HTMLAttributes, useState } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { Eye, EyeOff } from 'lucide-react';
import { FieldWrapper, FieldWrapperPassThroughProps } from './FieldWrapper';

type PasswordInputFieldProps = FieldWrapperPassThroughProps & {
  className?: string;
  inputMode?: HTMLAttributes<HTMLInputElement>['inputMode'];
  registration: Partial<UseFormRegisterReturn>;
};

export const PasswordInputField = (props: PasswordInputFieldProps) => {
  const {
    inputMode,
    label,
    placeholder,
    className,
    registration,
    error,
  } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const handleClickVisible = (e: any) => {
    e.preventDefault();
    setVisible(!visible)
  }
  return (
    <FieldWrapper label={label} error={error}>
      <div className='relative' >
        <input
          type={visible ? "text" : "password"}
          placeholder={placeholder}
          autoComplete="off"
          inputMode={inputMode}
          className={clsx(
            'appearance-none block h-[50px] px-[20px] md:px-[33px] py-2 rounded shadow-sm drop-shadow placeholder-[#CCCED1] focus:outline-none focus:ring-primary sm:text-sm',
            [error?.message ? 'border border-1 border-red' : 'border-none'],
            className
          )}
          {...registration}
        /> 
        <button onClick={handleClickVisible} className='absolute right-5 md:top-7 top-5'>
        {visible ? <EyeOff size={20} /> : <Eye size={20} /> }
        </button>
      </div>
    </FieldWrapper>
  );
};
